module.exports = __webpack_public_path__ + "files/fc2b91103d79abad24d07c7fde3076d5.gif";